export default __webpack_public_path__ + "static/media/bg4.c8f41d9d.png";